import { useState } from 'react';

import { EnumReference } from '../../Models/EnumReference';
import { EnumerationInputDialog } from './EnumerationInputDialog';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';

type EnumerationInputProps = {
	enumRef: EnumReference | undefined;
	onEnumRefChange: (enumRef: EnumReference | undefined) => void;
	isEditable?: boolean;
};

export default function EnumerationInput({ enumRef, onEnumRefChange, isEditable = true }: EnumerationInputProps) {
	const [open, setOpen] = useState(false);

	if (!isEditable) {
		return <GenericPropertyInputRefContent value={enumRef} />;
	}

	return (
		<GenericPropertyInput value={enumRef} onValueChange={onEnumRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={enumRef} />
			{open && <EnumerationInputDialog open={open} setOpen={setOpen} enumRef={enumRef} onEnumRefChange={onEnumRefChange} />}
		</GenericPropertyInput>
	);
}
